import {Component, ViewChild, OnInit, AfterViewInit, ElementRef, Input} from '@angular/core';
import * as moment from "moment/moment";
import { Router } from '@angular/router';
import {NotesService} from "../../models/notes/notes.service";
import {NotesType} from "../../models/notes/notes.type";
import {NotesModes} from "./notes.modes";
import {RoleTypes} from "../../models/roles";
import {ToasterService} from 'angular2-toaster/angular2-toaster';
import {ValidationService} from "../../services/validation.service";
import {ApplicationUser} from "../../services/ApplicationUser";
import {SlackApi} from "../../components/slack-api/slack-api.component";
import {PermissionsService} from "../../services/permissions/permissions.service";
import {dateTimeHelper} from "../../helpers/date";

@Component({
    selector: 'notes',
    templateUrl: 'notes.template.html',
    styleUrls: ['notes.component.css'],
    exportAs: 'notes'
})

export class NotesComponent implements OnInit, AfterViewInit {

    @ViewChild('confirmDialog') public confirmDialog;
    @Input('clientId') public clientId;
    @Input('notesMode') public notesMode: NotesModes;

    public notes = [];

    public salesNotes;
    public customerNotes = '';
    public opportunityNotes = '';
    public collectionNotes = '';
    public landlordNotes = '';
    public underwritingNotes = '';
    public $customerNotesForm;
    public $opportunityNotesForm;
    public $collectionNotesForm;
    public $landlordNotesForm;
    public $underwritingNotesForm;
    public $salesNotesForm;

    public notesType = NotesType;

    public removeData: any;

    public userRole;
    public roleTypes = RoleTypes;
    public modes = NotesModes;

    public slackUsers: Array<any> = [];

    constructor(
                private toasterService: ToasterService,
                protected validationService: ValidationService,
                protected el: ElementRef,
                public appUser: ApplicationUser,
                private notesService: NotesService,
                private slackApi: SlackApi,
                public permissionsService: PermissionsService,
                private router: Router) {

        this.userRole = this.appUser.user.role;

    }

    ngOnInit() {
        this.refresh();

    }

    refresh() {
        this.notesService.getList({client_id: this.clientId})
            .subscribe((res) => {
                this.notes = res.data;

                this.notes.map(item => {
                    item.created_at = moment(item.created_at).format('DD MMM YYYY HH:mm');
                });
            });

        this.getUsers();
    }

    ngAfterViewInit() {

        this.$salesNotesForm = $('[name="sales-notes-form"]', this.el.nativeElement);
        this.$customerNotesForm = $('[name="customer-notes-form"]', this.el.nativeElement);
        this.$opportunityNotesForm = $('[name="opportunity-notes-form"]', this.el.nativeElement);
        this.$collectionNotesForm = $('[name="collection-notes-form"]', this.el.nativeElement);
        this.$landlordNotesForm = $('[name="landlord-notes-form"]', this.el.nativeElement);
        this.$underwritingNotesForm = $('[name="underwriting-notes-form"]', this.el.nativeElement);

        this.validateForm();
    }

    public confirmRemoveNote(removeData: any) {
        this.removeData = removeData;
        this.confirmDialog.show('Do you want delete this notes?');
    }

    public removeNote(removeItem) {

        this.notesService.remove(removeItem.id)
            .subscribe(
                () => {
                    this.toasterService.pop('success', 'Success', 'Notes removed');
                    delete this.notes[removeItem.index];
                },
                (error) => {
                    let errorData = JSON.parse(error._body);
                    this.toasterService.pop('error', 'Error', errorData.message);
                });
    }

    public getUsers() {
        this.slackApi.getMentions()
            .subscribe((res) => {
                this.slackUsers = res.data.filter(x => x);
            });
    }

    get canNotesRead(): boolean {
        return this.permissionsService.can('notes.read');
    }
    get canNotesDelete(): boolean {
        return this.permissionsService.can('notes.delete');
    }

    get canLandlord(): boolean {
        return this.permissionsService.can('notes.landlord');
    }

    get canUnderwriting(): boolean {
        return this.permissionsService.can('notes.underwriting');
    }

    private validateForm() {
        this.$salesNotesForm
            .validate({
                submitHandler: (form) => {
                    this.notesService.add({client_id: this.clientId, message: this.salesNotes, type: this.notesType.SALES_NOTE, url: this.router.url})
                        .subscribe(
                            (res) => {
                                res.data.created_at = moment(res.data.created_at).format('DD MMM YYYY HH:mm');
                                this.notes = [res.data].concat(this.notes);
                                this.toasterService.pop('success', 'Success', 'Saved'); //todo
                                this.salesNotes = '';
                            },
                            (error) => {
                                this.validationService.showError(error, form);
                            });
                }
            });

        this.$customerNotesForm
            .validate({
                submitHandler: (form) => {
                    this.notesService.add({client_id: this.clientId, message: this.customerNotes, type: this.notesType.CUSTOMER_SERVICE_NOTE, url: this.router.url})
                        .subscribe(
                            (res) => {
                                res.data.created_at = moment(res.data.created_at).format('DD MMM YYYY HH:mm');
                                this.notes = [res.data].concat(this.notes);
                                this.toasterService.pop('success', 'Success', 'Saved'); //todo
                                this.customerNotes = '';
                            },
                            (error) => {
                                this.validationService.showError(error, form);
                            });
                }
            });

        this.$opportunityNotesForm
            .validate({
                submitHandler: (form) => {
                    this.notesService.add({client_id: this.clientId, message: this.opportunityNotes, type: this.notesType.OPPORTUNITY_NOTE, url: this.router.url})
                        .subscribe(
                            (res) => {
                                res.data.created_at = moment(res.data.created_at).format('DD MMM YYYY HH:mm');
                                this.notes = [res.data].concat(this.notes);
                                this.toasterService.pop('success', 'Success', 'Saved'); //todo
                                this.opportunityNotes = '';
                            },
                            (error) => {
                                this.validationService.showError(error, form);
                            });
                }
            });

        this.$collectionNotesForm
            .validate({
                submitHandler: (form) => {
                    this.notesService.add({client_id: this.clientId, message: this.collectionNotes, type: this.notesType.COLLECTION_NOTE, url: this.router.url})
                        .subscribe(
                            (res) => {
                                res.data.created_at = moment(res.data.created_at).format('DD MMM YYYY HH:mm');
                                this.notes = [res.data].concat(this.notes);
                                this.toasterService.pop('success', 'Success', 'Saved'); //todo
                                this.collectionNotes = '';
                            },
                            (error) => {
                                this.validationService.showError(error, form);
                            });
                }
            });

        this.$landlordNotesForm
            .validate({
                submitHandler: (form) => {
                    this.notesService.add({client_id: this.clientId, message: this.landlordNotes, type: this.notesType.LANDLORD_NOTE, url: this.router.url})
                        .subscribe(
                            (res) => {
                                res.data.created_at = moment(res.data.created_at).format('DD MMM YYYY HH:mm');
                                this.notes = [res.data].concat(this.notes);
                                this.toasterService.pop('success', 'Success', 'Saved'); //todo
                                this.landlordNotes = '';
                            },
                            (error) => {
                                this.validationService.showError(error, form);
                            });
                }
            });

        this.$underwritingNotesForm
            .validate({
                submitHandler: (form) => {
                    this.notesService.add({client_id: this.clientId, message: this.underwritingNotes, type: this.notesType.UNDERWRITING_NOTE, url: this.router.url})
                        .subscribe(
                            (res) => {
                                res.data.created_at = moment(res.data.created_at).format('DD MMM YYYY HH:mm');
                                this.notes = [res.data].concat(this.notes);
                                this.toasterService.pop('success', 'Success', 'Saved'); //todo
                                this.underwritingNotes = '';
                            },
                            (error) => {
                                this.validationService.showError(error, form);
                            });
                }
            });
    }

    dateDisplayFormat(date) {
        try {
            return dateTimeHelper.dateFormatUSA(date, false) + ' ' + dateTimeHelper.get24Time(date, false);
        } catch (e) {
            return '';
        }
    }


}


// WEBPACK FOOTER //
// ./src/app/modules/notes/notes.component.ts